import React, { useEffect } from "react";
import { useForm, Controller } from "react-hook-form";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    Button,
    Box,
} from "@mui/material";

const ComponentTypeForm = ({ open, handleClose, onSubmit, defaultValues }) => {
    // Inicializar useForm con los valores por defecto
    const {
        handleSubmit,
        control,
        reset,
        formState: { errors },
    } = useForm({
        defaultValues: {
            tipcomnom: "",
            tipcomdes: "",
            ...defaultValues, // Sobrescribirá si defaultValues tiene propiedades
        },
    });

    // Resetear el formulario cuando se abre o los defaultValues cambian (para modo edición)
    useEffect(() => {
        reset({
            tipcomnom: "",
            tipcomdes: "",
            ...defaultValues,
        });
    }, [defaultValues, reset]);

    const handleFormSubmit = (data) => {
        onSubmit(data); // Llama a la función onSubmit pasada desde el Dashboard
    };

    return (
        <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
            <DialogTitle>{defaultValues.tipcomid ? "Editar Tipo de Componente" : "Crear Tipo de Componente"}</DialogTitle>
            <DialogContent dividers>
                <Box component="form" noValidate sx={{ mt: 1 }}>
                    {/* Campo Nombre del Tipo de Componente */}
                    <Controller
                        name="tipcomnom"
                        control={control}
                        rules={{ required: "El nombre del tipo de componente es obligatorio." }}
                        render={({ field }) => (
                            <TextField
                                {...field}
                                autoFocus
                                margin="dense"
                                label="Nombre del Tipo de Componente"
                                type="text"
                                fullWidth
                                variant="outlined"
                                error={!!errors.tipcomnom}
                                helperText={errors.tipcomnom?.message}
                            />
                        )}
                    />

                    {/* Campo Descripción del Tipo de Componente */}
                    <Controller
                        name="tipcomdes"
                        control={control}
                        render={({ field }) => (
                            <TextField
                                {...field}
                                margin="dense"
                                label="Descripción"
                                type="text"
                                fullWidth
                                variant="outlined"
                                multiline
                                rows={3}
                                error={!!errors.tipcomdes}
                                helperText={errors.tipcomdes?.message}
                            />
                        )}
                    />
                </Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} color="inherit">
                    Cancelar
                </Button>
                <Button onClick={handleSubmit(handleFormSubmit)} variant="contained" color="primary">
                    {defaultValues.tipcomid ? "Guardar Cambios" : "Crear"}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ComponentTypeForm;